import {
	collectShapeIdsFromAgentTool,
	recordAgentSessionTouchedShapes,
	removeAgentSessionTouchedShapes,
} from "./agent-session-shape-tracker";
import { isAgentBoardMutationTool } from "./board-agent-config";

export function trackAgentBoardToolMutation({
	toolName,
	input,
	output,
}: {
	toolName: string;
	input: unknown;
	output: unknown;
}) {
	if (!isAgentBoardMutationTool(toolName)) {
		return;
	}

	const shapeIds = collectShapeIdsFromAgentTool(toolName, input, output);
	if (shapeIds.length === 0) {
		return;
	}

	if (toolName === "deleteShape" || toolName === "deleteCard") {
		removeAgentSessionTouchedShapes(shapeIds);
		return;
	}

	recordAgentSessionTouchedShapes(shapeIds);
}
